module.exports = __webpack_public_path__ + "media/honey-icons/icon-back-455a4b11.svg";